<script lang="ts">
	import { ArtistsAboutId } from '../../constants';
	import { ArtistUpdatesCard } from '../ArtistUpdatesCard';
	import { page } from '$app/state';
	import { FacebookIcon } from '$global/assets/icons/FacebookIcon';
	import { GlobeIcon } from '$global/assets/icons/GlobeIcon';
	import { InstagramIcon } from '$global/assets/icons/InstagramIcon';
	import { TwitterXIcon } from '$global/assets/icons/TwitterXIcon';
	import { IconLink } from '$global/components/IconLink';
	import { Markdown } from '$global/components/Markdown';
	import { Txt } from '$global/components/Txt';
	import type { ArtistsPageData } from '$routes/artists/[slug]/types';

	interface Props {
		dataCy: string;
		class?: string;
	}

	let { ...props }: Props = $props();

	const handleReadFull = (event: Event) => {
		event.preventDefault();
		const targetElement = document.querySelector(
			`span[data-cy=${ArtistsAboutId}]`
		);

		if (targetElement) {
			targetElement.scrollIntoView({
				behavior: 'smooth',
			});
		}
	};

	let artist = $derived(page.data.artist as ArtistsPageData['artist']);
	let dataCyPrefix = $derived(`${props.dataCy}-artists-bio`);
</script>

<div class={props.class}>
	<div class="flex flex-col items-start justify-between sm:flex-row">
		<Txt variant="h1" class="mb-4 font-light tracking-widest uppercase sm:mb-12"
			>{artist?.name || ''}</Txt
		>
		<div class="mb-4 flex gap-2 sm:mb-0">
			{#if artist.instagram_link}
				<IconLink
					dataCy={`${dataCyPrefix}-instagram`}
					label="Go to Instagram"
					href={artist.instagram_link}
					target="_blank"
					rel="noopener noreferrer"
				>
					<InstagramIcon />
				</IconLink>
			{/if}
			{#if artist.twitter_link}
				<IconLink
					dataCy={`${dataCyPrefix}-x-twitter`}
					label="Go to X.com"
					href={artist.twitter_link}
					target="_blank"
					rel="noopener noreferrer"
				>
					<TwitterXIcon />
				</IconLink>
			{/if}
			{#if artist.facebook_link}
				<IconLink
					dataCy={`${dataCyPrefix}-facebook`}
					label="Go to FaceBook"
					href={artist.facebook_link}
					target="_blank"
					rel="noopener noreferrer"
				>
					<FacebookIcon />
				</IconLink>
			{/if}
			{#if artist.official_website_link}
				<IconLink
					dataCy={`${dataCyPrefix}-website`}
					label="Go to artist website"
					href={artist.official_website_link}
					target="_blank"
					rel="noopener noreferrer"
				>
					<GlobeIcon />
				</IconLink>
			{/if}
		</div>
	</div>
	<div class="mb-12 border-b border-gray-200 sm:mb-6"></div>

	<div class="flex flex-col sm:flex-row">
		<div class="mr-8 flex flex-1 flex-col items-start lg:mr-[7.5rem]">
			<Markdown
				dataCy="drop-timeline-entry-content"
				class="lg:[&_p]:leading-[1.75rem] lg:[&_span]:leading-[1.75rem]"
				source={artist?.bioShortTokens ?? []}
			/>
			<a
				href={`#${ArtistsAboutId}`}
				data-cy={`${dataCyPrefix}-show-bio`}
				onclick={handleReadFull}
				class="mb-6 uppercase"
			>
				<Txt component="span" variant="label3" class="px-0 tracking-widest"
					>READ FULL BIOGRAPHY</Txt
				>
			</a>
		</div>
		<div class="w-[full] sm:w-[320px]">
			<ArtistUpdatesCard
				dataCy={dataCyPrefix}
				src={artist?.image?.filename_disk}
				artistName={artist?.name || ''}
				listId={artist?.news_letter_list_id_prod || 0}
				testListId={artist?.news_letter_list_id_dev || 0}
			/>
		</div>
	</div>
</div>
